import { render } from "./0.vue?vue&type=template&id=02700888&scoped=true"
import script from "./0.vue?vue&type=script&lang=js"
export * from "./0.vue?vue&type=script&lang=js"

import "./0.vue?vue&type=style&index=0&id=02700888&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02700888"]])

export default __exports__